type addRating = {
  Rating(value: string): string;
  Grade(value: string, previousGrades: string[]): string;
  Description(value: string): string;
};

const validateRating = (value: string) => {
  if (value.trim().length === 0) return "Required.";
  if (value.trim().length > 20) return "20 characters max.";

  return "";
};

const validateDescription = (value: string) => {
  if (value.trim().length === 0) return "Required.";
  if (value.trim().length > 250) return "250 characters max.";

  return "";
};

//TODO: for grade
const validateGrade = (value: string, previousGrades: string[]) => {
  if (value.trim().length === 0 && previousGrades.length === 0)
    return "Required.";
  if (value.trim().length > 20) return "20 characters max.";

  return "";
};

const validator: addRating = {
  Rating: validateRating,
  Description: validateDescription,
  Grade: validateGrade,
};

export default validator;
